import { Container, Grid } from '@aurecon-creative-technologies/styleguide'
import { FC, useEffect, useState } from 'react'
import { StatusQuery } from '../api/StatusAPI'

import Page from '../components/Page'
import Style from '../styles/AddProjectPage.module.sass'

const ServiceStatus: FC = () => {
  const [status, statusSet] = useState({
    database: false,
    gis: false,
  })
  useEffect(() => {
    const getstatus = async () => {
      const rs = await StatusQuery({})
      statusSet(rs?.data?.status)
    }

    getstatus()
  }, [])

  return (
    <Page footer>
      <Container cssClass={Style.pageWrapper}>
        <Grid cssClass={Style.body}>
          <Grid item cssClass={Style.content} xs={3} md={3}>
            Database
          </Grid>
          <Grid item cssClass={Style.content} xs={9} md={9}>
            {status.database ? 'Online' : 'Offline'}
          </Grid>
          <Grid item cssClass={Style.content} xs={3} md={3}>
            GIS
          </Grid>
          <Grid item cssClass={Style.content} xs={9} md={9}>
            {status.gis ? 'Online' : 'Offline'}
          </Grid>
        </Grid>
      </Container>
    </Page>
  )
}

export default ServiceStatus
